export default "__VITE_ASSET__7800b886__"